export default {
   components: {
      
   },
   routes: [
      
   ],
   sub_routes: [
      {
         path: '/dashboard',
         component: () => import(`./dashboard/dashboard`),
         name: 'Main_Dashboard'
      },
   ]
}
